import { safeGet } from '../../../../core/utils/safe-get.js';
import type { AxisIdToScales } from '../../../context/XYChartScales.context.js';
import type { XYChartAxisInternal } from '../../../types/xy-chart-internals.js';

export function isAxisPannable(
  axis: XYChartAxisInternal | undefined,
  scales: AxisIdToScales,
): boolean {
  if (!axis || axis.type === 'categorical' || axis?.interactions.pan !== true) {
    return false;
  }

  const { currentScale, initialScale } = safeGet(scales, axis.id);

  const [currentMin, currentMax] = currentScale.domain();
  const [initialMin, initialMax] = initialScale.domain();

  const differentLeftDomain = currentMin.valueOf() !== initialMin.valueOf();

  const differentRightDomain = currentMax.valueOf() !== initialMax.valueOf();

  return (
    differentLeftDomain ||
    differentRightDomain ||
    axis?.interactions.infinite === true
  );
}
